<div class="row coreteam-item">
    <div class="col-sm-2">
    <p><a href="#coreteamexecutive">Executive Team</a></p>
    <p><a href="#coreteamadvisors">Advisory Board</a></p>
    
    </div>
    <div class="col-sm-3">
        <img src="/assets/images/coreteam/benja_200.png" width="250px">
    </div>
    <div class="col-sm-7">
    <h4>Benjamin Kanagwa</h4>
    <p><u>Chief Executive Officer (CEO)</u></p>
    Associate Professor Benjamin Kanagwa leads the executive team for achieving the vision and mission of Boldungu. Benjamin has  over 15 years of experience as  practitioner  for startup companies as well as  consultant for well-established multinational corporation. Benjamin believes that learning should be fun and should happen by doing. He brings not only executive leadership but also technical leadership in relation to software engineering and content development.</div>
    </div>
